import {Component, Input} from '@angular/core';
import {IGameQueryResult} from "../../interfaces/IGameQueryResult";
import {ViewCharityPayoutsComponent} from "./view-charity-payouts/view-charity-payouts.component";
import {AddCharityPayoutsComponent} from "./add-charity-payouts/add-charity-payouts.component";
import {CharityBalancesSummaryComponent} from "./charity-balances-summary/charity-balances-summary.component";
import {CharityAdjustmentsComponent} from "./charity-adjustments/charity-adjustments.component";
import {CharityPayeesComponent} from "./charity-payees/charity-payees.component";
import {ColComponent, ContainerComponent, ListGroupDirective, ListGroupItemDirective, RowComponent} from "@coreui/angular";
import {HasPermissionDirective} from "../../directives/permissions/has-permission";
import {PermissionTypes} from "../../enum/PermissionTypes";

enum ScreenState {
  BalancesSummary,
  ViewPayouts,
  AddPayout,
  Adjustments,
  Payees
}

@Component({
  selector: 'app-charity-payouts',
  standalone: true,
  templateUrl: './charity-payouts.component.html',
  imports: [
    ViewCharityPayoutsComponent,
    AddCharityPayoutsComponent,
    CharityBalancesSummaryComponent,
    CharityAdjustmentsComponent,
    CharityPayeesComponent,
    ContainerComponent,
    RowComponent,
    ColComponent,
    ListGroupDirective,
    ListGroupItemDirective,
    HasPermissionDirective
  ],
  styleUrls: ['./charity-payouts.component.scss']
})
export class CharityPayoutsComponent {

  @Input() set gameSetter(gameData: { gameP: IGameQueryResult, isCrossGame: boolean }) {
    // Reset selectedCharityId when game changes
    if (this.activeGame && this.activeGame.Id !== gameData.gameP.Id) {
      this.selectedCharity = null;
    }
    this.activeGame = gameData.gameP;
  }

  public activeGame: IGameQueryResult | null = null;
  public currentScreenState: ScreenState = ScreenState.BalancesSummary;
  protected readonly ScreenState = ScreenState;
  public selectedCharity: { id: string; name: string } | null = null;
  protected readonly permissionTypes = PermissionTypes;

  onPayoutCreated(): void {
    this.currentScreenState = ScreenState.BalancesSummary;
    this.selectedCharity = null; // Reset the selected charity

    // Nothing to refresh by hand: the tabs are an @switch, so View Charity Payouts is destroyed on the way out and
    // re-reads the game's payouts when it is created again.
  }

  onMakePayoutClick(charityP: { id: string; name: string }): void {
    this.selectedCharity = charityP;
    this.currentScreenState = ScreenState.AddPayout;
  }

  // Reset selected charity when manually navigating to Add Payout tab
  navigateToAddPayout(): void {
    this.selectedCharity = null;
    this.currentScreenState = ScreenState.AddPayout;
  }
}
